import {
    CalendarSingleDayIcon,
    ContactIcon,
    GalleryOutlineIcon,
    ProgressIcon,
    PropertyPlanIcon,
    ScreenProgressIcon,
    SmartSearchIcon
} from "@pg-design/icons-module";

import {UnlockChoiceOptionIcon} from "../../../types/IUnlockChoiceOption";

interface IProps {
    icon: UnlockChoiceOptionIcon;
}

export const UnlockChoiceModalOptionIcon = (props: IProps) => {
    const {icon} = props;

    switch (icon) {
        case "chat":
            return <ContactIcon size="2.4" />;
        case "calendar":
            return <CalendarSingleDayIcon size="2.4" />;
        case "screen_chart":
            return <ScreenProgressIcon size="2.4" />;
        case "floor_plan":
            return <PropertyPlanIcon size="2.4" />;
        case "price_history":
            return <ProgressIcon size="2.4" />;
        case "camera":
            return <GalleryOutlineIcon size="2.4" />;
        case "ai_search":
            return <SmartSearchIcon size="2.4" />;
        default:
            return null;
    }
};
import {
    CalendarSingleDayIcon,
    ContactIcon,
    GalleryOutlineIcon,
    ProgressIcon,
    PropertyPlanIcon,
    ScreenProgressIcon,
    SmartSearchIcon
} from "@pg-design/icons-module";

import {UnlockChoiceOptionIcon} from "../../../types/IUnlockChoiceOption";

interface IProps {
    icon: UnlockChoiceOptionIcon;
}

export const UnlockChoiceModalOptionIcon = (props: IProps) => {
    const {icon} = props;

    switch (icon) {
        case "chat":
            return <ContactIcon size="2.4" />;
        case "calendar":
            return <CalendarSingleDayIcon size="2.4" />;
        case "screen_chart":
            return <ScreenProgressIcon size="2.4" />;
        case "floor_plan":
            return <PropertyPlanIcon size="2.4" />;
        case "price_history":
            return <ProgressIcon size="2.4" />;
        case "camera":
            return <GalleryOutlineIcon size="2.4" />;
        case "ai_search":
            return <SmartSearchIcon size="2.4" />;
        default:
            return null;
    }
};
